// extracted by mini-css-extract-plugin
module.exports = {"brandLogo":"styles_brandLogo___UmLP","responsiveBrandLogo":"styles_responsiveBrandLogo__s4qDG"};